import axios from "axios";
// import baseApiUrl from "./BaseService";

const baseApiUrl = process.env.REACT_APP_API_URL;


export function createObject(API_URL, object, methodName) {
  if (!methodName) methodName = "create";
  return axios.post(`${baseApiUrl}/${API_URL}/${methodName}`, object);
}

export function getAllObjects(API_URL) {
  return axios.get(`${baseApiUrl}/${API_URL}/getAll`);
}

export function getFile(API_URL, queryParams, funcName) {
  return axios.post(`${baseApiUrl}/${API_URL}/${funcName}`, queryParams, {
    responseType: "arraybuffer",
  });
}

export function getObjectById(API_URL, objectId, methodName) {
  if (!methodName) methodName = "get";
  return axios.get(`${baseApiUrl}/${API_URL}/${methodName}/${objectId}`);
}

export function findObjects(API_URL, queryParams, getFunctionName) {
  var method = "query"
  if (getFunctionName) method = getFunctionName
  return axios.post(`${baseApiUrl}/${API_URL}/${method}`, queryParams);
}

export function findObjectsById(API_URL, id, queryParams, getFunctionName) {
  var method = "query"
  if (getFunctionName) method = getFunctionName
  return axios.post(`${baseApiUrl}/${API_URL}/${method}`, { id, ...queryParams });
}

export function updateObject(API_URL, object) {
  // return axios.put(`${baseApiUrl}/${API_URL}/update/${object.id}`, object);
  return axios.put(`${baseApiUrl}/${API_URL}/update`, object);
}

export function updateObjects(API_URL, ids, object, methodName) {
  if (!methodName) methodName = "updateRange";
  return axios.put(`${baseApiUrl}/${API_URL}/${methodName}`, { idList: ids, updateValues: object });
}

export function updateSeatResultsFromUserObject(API_URL, id, ids, object, methodName) {
  var method = "updateRange"
  if (methodName) method = methodName
  return axios.put(`${baseApiUrl}/${API_URL}/${method}`,
    {
      auditFormListId: id,
      idList: ids,
      idNumber: object.idNumber,
      firstName: object.firstName,
      lastName: object.lastName,
      nationalCode: object.nationalCode,
    }
  );
}

export function updateResultStatusObjects(API_URL, id, ids, object, methodName) {
  var method = "updateRange"
  if (methodName) method = methodName
  return axios.put(`${baseApiUrl}/${API_URL}/${method}`, { auditFormListId: id, idList: ids, updateValues: object });
}

export function updateStatusForObjects(API_URL, ids, isDeleted) {
  if (isDeleted)//status=isdeleted=true => deleteRange
  {
    return axios.put(`${baseApiUrl}/${API_URL}/SoftDeleteRange`, { idList: ids });
  }
  else {//status=isdeleted=false => RecoverDeleteRange
    return axios.put(`${baseApiUrl}/${API_URL}/RecoverDeleteRange`, { idList: ids });
  }
}

export function deleteObject(API_URL, objectId) {
  // return axios.delete(`${baseApiUrl}/${API_URL}/SoftDelete/${objectId}`);
  return axios.put(`${baseApiUrl}/${API_URL}/SoftDelete/${objectId}`);
}

export function deleteObjects(API_URL, ids) {
  return axios.put(`${baseApiUrl}/${API_URL}/SoftDeleteRange`, { idList: ids });
}

export function hardDeleteObject(API_URL, objectId) {
  // return axios.delete(`${baseApiUrl}/${API_URL}/SoftDelete/${objectId}`);
  return axios.delete(`${baseApiUrl}/${API_URL}/HardDelete/${objectId}`);
}

export function hardDeleteObjects(API_URL, ids) {
  // return axios.delete(`${baseApiUrl}/${API_URL}/SoftDelete/${objectId}`);
  return axios.put(`${baseApiUrl}/${API_URL}/HardDeleteRange`, { idList: ids });
}
